import { useState } from 'react'
import { Box, Card, CardBody, CardHeader, Flex, Heading } from '@chakra-ui/react'
import { UiBreadcrumb } from 'components/common'
import { createArtworkRequest, createArtworkRequestNote } from 'api'
import { useAppContext } from 'hooks/useAppContext'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { ArtworkRequestForm, ArtworkRequestFormType } from './ArtworkRequestForm'
import { ARTWORK_REQUEST_STATUSES } from 'lib'

const BreadcrumbNav = [
  {
    label: 'Artwork Requests',
    path: '/artwork-requests/queue'
  },
  {
    label: 'Add',
    isCurrentPage: true
  }
]

export const AddArtworkRequest = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const quoteNumber = searchParams.get('quoteNumber') || ''
  const { createToast, currentUser } = useAppContext()
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleAdd = async (form) => {
    setIsSubmitting(true)

    try {
      const request = await createArtworkRequest({
        salesUserId: currentUser?.id || 0,
        assignedGraphicDesignerId: form.assignedGraphicDesigner?.id || 0,
        quoteNumber: form.quoteNumber,
        projectName: form.projectName,
        status: ARTWORK_REQUEST_STATUSES.NotYetStarted,
        priority: form.priority
      })
      await createArtworkRequestNote({
        requestId: request.id,
        notes: form.notes,
        attachments: form.attachments
      })
      createToast('success', 'Artwork request created')
      navigate('/artwork-requests/queue')
      setIsSubmitting(false)
    } catch (err) {
      createToast('error', 'Error', err.response.data)
      setIsSubmitting(false)
    }
  }

  return (
    <>
      <UiBreadcrumb items={BreadcrumbNav} />
      <Box>
        <Flex justifyContent="space-between" alignItems="center" my={8}>
          <Heading size="lg">Add Artwork Request</Heading>
        </Flex>
        <Card borderRadius={0}>
          <CardHeader bg="gray.500" p={4}>
            <Heading color="white" size="sm">Information</Heading>
          </CardHeader>
          <CardBody p={8}>
            <ArtworkRequestForm
              type={ArtworkRequestFormType.Add}
              onSubmit={handleAdd}
              isSubmitting={isSubmitting}
              initialForm={{ quoteNumber }}
            />
          </CardBody>
        </Card>
      </Box>
    </>
  )
}
